import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from "./privateRoutes";
import { AdminOnly } from '../components/AdminOnly';
import { Login } from '../pages/Login';
import { Home } from '../pages/Home';
import { Collaborator } from '../pages/Collaborator';
import { Reports } from '../pages/Reports';

export const Routers = () =>{
  return(
    <Routes>
      <Route path="/" element={<Login/>} />
      <Route path="/dashboard" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Home/>} path="/dashboard"/>
      </Route>
      <Route path="/collaborator" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Collaborator/>} path="/collaborator"/>
      </Route>
      <Route path="/reports" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Reports/>} path="/reports"/>
      </Route>
    </Routes>
  )
}